import React, { useContext } from "react";
import { FindifyNavigation } from "../components/FindifyNavigation";
import { Text, View } from "react-native";
import { PlaceColors } from "./PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { useSeoTitle } from "./SeoTitle";
import { useStatisticsPageView } from "./StatisticsHelper";

const routeSeoTitles: Record<string, Record<string, string>> = {
    Place: { 'pt-PT': 'Início', 'en-US': 'Home', 'en-GB': 'Home' },
    PlantsPage: { 'pt-PT': 'Visita Guiada', 'en-US': 'Guided Visit', 'en-GB': 'Guided Visit' },
    PlaceMap: { 'pt-PT': 'Mapa', 'en-US': 'Map', 'en-GB': 'Map' },
    PlaceInfo: { 'pt-PT': 'O Museu', 'en-US': 'The Museum', 'en-GB': 'The Museum' },
    PlaceContentList: { 'pt-PT': 'Conteúdos', 'en-US': 'Contents', 'en-GB': 'Contents' },
    PlaceContentDetails: { 'pt-PT': 'Conteúdo', 'en-US': 'Content', 'en-GB': 'Content' },
    ScanQR: { 'pt-PT': 'Ler QR Code', 'en-US': 'Scan QR Code', 'en-GB': 'Scan QR Code' },
    Scan: { 'pt-PT': 'Scanner', 'en-US': 'Scanner', 'en-GB': 'Scanner' },
    Profile: { 'pt-PT': 'Perfil', 'en-US': 'Profile', 'en-GB': 'Profile' },
    SchedulePage: { 'pt-PT': 'Agenda', 'en-US': 'Schedule', 'en-GB': 'Schedule' },
};

const getRouteSeoTitle = (routeName?: string, language?: string) => {
    const title = routeSeoTitles[routeName ?? ''];
    if (!title) return routeName;
    return title?.[language ?? ''] ?? title?.['pt-PT'] ?? Object.values(title)[0];
}

const getWorkspaceSeoTitle = (workspace: any, language?: string) => {
    const title = workspace?.name ?? workspace?.app_settings?.app_name;
    if (typeof title === 'string') return title;
    if (title && typeof title === 'object') {
        return title?.[language ?? ''] ?? title?.['pt-PT'] ?? title?.['en-US'] ?? title?.['en-GB'] ?? Object.values(title)[0];
    }
    return 'Rota de Museus de Caminha';
}

const normalizeViewChildren = (children: React.ReactNode) => {
    return React.Children.map(children, (child) => {
        if (typeof child === 'string') {
            if (child.trim().length === 0) return null;
            return <Text>{child}</Text>;
        }

        if (typeof child === 'number') {
            return <Text>{child}</Text>;
        }

        return child;
    });
}

export const BasePage = ({ ...props }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const currentRoute = props.navigation?.getState?.()?.routes?.[props.navigation?.getState?.()?.index ?? 0];
    useSeoTitle(
        props.seoTitle ?? getRouteSeoTitle(currentRoute?.name, findifyDataContext?.language),
        getWorkspaceSeoTitle(findifyDataContext?.workspace, findifyDataContext?.language) as string
    );
    useStatisticsPageView({
        findifyDataContext,
        routeName: currentRoute?.name,
        routeParams: currentRoute?.params,
        enabled: !props.hideBottomNavigation,
    });
    
    return <View style={{ flex: 1, backgroundColor: PlaceColors(findifyDataContext).background.get() }}>
        {normalizeViewChildren(props.children)}
        {!props.hideBottomNavigation &&
            <FindifyNavigation navigation={props.navigation} />
        }
    </View>;
};  
